/**
 * Legacy employer-specific components
 *
 * These components were moved from @restworld/ui-components
 * because they are only used by the employer app.
 */
export * from './employer-activity-card';
export * from './employer-candidate-card';
export * from './employer-collaborator-card';
export * from './employer-flexible-slots-card';
export * from './employer-info-level-card';
export * from './employer-invoice-card/employer-invoice-card';
export * from './employer-performance-table';
export * from './employer-spontaneous-candidate-card';
export * from './contact-restworld-manager';
export * from './restworld-manager-card';
export * from './slot-purchase-card/slot-purchase-card';
export * from './flexible-slot-card/flexible-slot-card';
export * from './employer-card-utils';
export * from './nav-menu-item';
export * from './v2-link';
export * from './new-candidate-notification';
export * from './section-accordion';
export * from './title-and-button-wrapper';
export * from './employer-job-listing-card';
export * from './combobox';

// Disambiguate `export *` collisions: these members are defined in more than one
// of the modules above. Explicitly re-export the canonical source (an explicit
// re-export takes precedence over the wildcard re-exports, resolving TS2308).
export { TitleAndButtonWrapper } from './title-and-button-wrapper';
export { badgeVariant, bagdeText } from './employer-card-utils';
